/**
 * Deterministically converts a string into a bright hex color.
 * The same input always produces the same output, so identifiers
 * like "B002129996000000" map to a stable color on the map.
 *
 * Returns a #rrggbb string. Google Maps Polyline strokeColor only
 * accepts hex / named CSS colors, not hsl() — passing hsl() makes
 * the line render black, which is what caused the "all black" bug.
 */

const hslToHex = (h, s, l) => {
    const sn = s / 100;
    const ln = l / 100;

    const k = n => (n + h / 30) % 12;
    const a = sn * Math.min(ln, 1 - ln);
    const f = n => {
        const c = ln - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
        return Math.round(255 * c).toString(16).padStart(2, '0');
    };

    return `#${f(0)}${f(8)}${f(4)}`;
};

export const stringToColor = (str, { saturation = 90, lightness = 50 } = {}) => {
    if (str === null || str === undefined) {
        return '#000000';
    }

    const input = String(str);

    // FNV-1a 32-bit hash
    let hash = 0x811c9dc5;
    for (let i = 0; i < input.length; i++) {
        hash ^= input.charCodeAt(i);
        hash = (hash + ((hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24))) >>> 0;
    }

    const hue = hash % 360;
    return hslToHex(hue, saturation, lightness);
};

export default stringToColor;
